import { Box, Typography, Stack } from "@mui/material";
import React from "react";

const ExerciseVideos = ({ exerciseVideos, name }) => {

  return (
    <Box sx={{ marginTop: { lg: "200px", xs: "20px" } }} p="20px">
      <Typography variant="h3" mb="33px">
        Watch{" "}
        <span style={{ color: "ff2625", textTransform: "capitalize" }}>
          {name}{" "}
        </span>
        exercise videos
      </Typography>
      <Stack
        justifyContent={"flex-start"}
        flexWrap="wrap"
        alignItems={"center"}
        sx={{ flexDirection: { lg: "row",md:'row' }, gap: { lg: "110px", xs: "0" } }}
      >
        {exerciseVideos?.slice(0, 6).map((item, index) => (
          <a
            key={index}
            className="exercise-video"
            href={`https://www.youtube.com/watch?v=${item.video.videoId}`}
            target="_blank"
            rel="noreferrer"
          >
            <img src={item.video.thumbnails[0].url} alt={item.video.title} style={{borderRadius:'10px'}} />
            <Box>
                <Typography sx={{color:'black'}}>
                    {item.video.title}
                </Typography>
                <Typography>
                    {item.video.channelName}
                </Typography>
            </Box>
          </a>
        ))}
      </Stack>
    </Box>
  );
};

export default ExerciseVideos;
